import SanitizeInput from "./sanitizeInput";

export default {
  install(Vue) {
    Vue.use(SanitizeInput);
  }
};



// WEBPACK FOOTER //
// ./src/directives/index.js